import { Grid, Heading, Text } from '@simplywallst/ui-core';

import { formatterCurrencyTruncated } from '@/utilities/format';

import { PriceTargetUpdatedFrom } from './PriceTargetUpdatedFrom';

import type { PriceTargetHistory } from '../../hooks/useCompanyPriceTargetHistory';

type PriceTargetTypes = PriceTargetHistory['priceTargetHistory'][number];

interface Props {
  priceTarget: PriceTargetTypes | undefined;
  previousPriceTarget: PriceTargetTypes | undefined;
}

export const PriceTarget = ({ priceTarget, previousPriceTarget }: Props) => {
  return (
    <Grid templateRows="auto auto" gap="2px" data-cy-id="price-target">
      <Heading as="h4" typography="tiny" color="whiteRGBA" opacity={0.5}>
        Average 1Y Price Target
      </Heading>
      {priceTarget ? (
        <Grid templateColumns="max-content auto" gap="6px">
          <Text typography="xSmall" data-cy-id="current-price-target">
            {formatterCurrencyTruncated(
              priceTarget.consensusMean,
              priceTarget.currencyISO
            )}
          </Text>
          {previousPriceTarget ? (
            <PriceTargetUpdatedFrom
              priceTarget={previousPriceTarget}
              updatedAt={priceTarget.fromDate}
            />
          ) : null}
        </Grid>
      ) : (
        <Text typography="xSmall" color="whiteRGBA" opacity={0.3}>
          n/a
        </Text>
      )}
    </Grid>
  );
};
